<template>
    <section>
        <div class="c">
            <Team></Team>

            <section class="team-vacatures clearfix">
                <div class="row">
                    <div class="hidden-sm-down col-md-4 col-lg-3 col-lg-offset-2 footer_img">
                        <img loading="lazy" :src="webdata('algemeen.0.afbeelding1')" class="-fullwidth boxshadow-m" />
                        <img loading="lazy" src="/img/logo.svg" class="footer_logo boxshadow" />
                    </div>
                    <div class="col-xs-12 col-md-6 col-md-offset-2 col-lg-6 col-lg-offset-1 footer_text">
                        <div class="hidden-md-up">
                            <img loading="lazy" src="/img/crown.svg" class="hidden-md-up crown" /><br />
                        </div>
                        <h2>{{ webdata('algemeen.0.naam', true) }}</h2>
                        <div v-html="webdata('algemeen.0.tekst', true)"> </div>
                        <router-link to="/vacatures/" class="button boxshadow">{{ $t('menu.jobs') }} &raquo;</router-link>
                    </div>
                </div>
                <br style="clear:both" /><br />
            </section>

            <Items :content="webdata('over_ons')"></Items>
        </div>
    </section>
</template>

<script>
import Items from '@/components/Items.vue';
import Team from '@/views/about/Team.vue';

export default {
    name: 'About',
    components: {
        Team,
        Items,
    },
};
</script>

<style>
.team-vacatures {
    display: block;
    background: var(--color-bg-darker);
    border: 0.1rem solid #ccc;
    border-radius: 0.8rem;
    padding: 3rem 3rem 1rem;
    color: var(--color-primary);
    margin-bottom: 6rem;
}
</style>
